import { Injectable } from '@angular/core';
import { Client, IMessage, Message, Stomp } from '@stomp/stompjs';
import { Observable, Subject } from 'rxjs';
import SockJS from 'sockjs-client';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class NotificationWebsocketService {
  private client: Client;
  private notificationSubject = new Subject<any>();
  private visitUpdateSubject = new Subject<any>();

  private username: string = '';
  private socketUrl = environment.serverUrl + 'ws';

  constructor() {
    console.log('Initializing WebSocket client with URL:', this.socketUrl);
    this.client = new Client({
      webSocketFactory: () => new SockJS(this.socketUrl),
      debug: (str) => {},
      reconnectDelay: 5000,
    });
    console.log('WebSocket client initialized:', this.client);
  }

  connect(username: string) {
  console.log('Connecting to WebSocket with username:', username);
  this.username = username;

  this.client.onConnect = () => {
    console.log('WebSocket connected successfully');

    // Subscribe to user-specific notifications
    this.client.subscribe(`/topic/notifications/${this.username}`, (message: IMessage) => {
      console.log('Received notification:', message.body);
      try {
        const payload = JSON.parse(message.body);
        this.notificationSubject.next(payload);
      } catch (e) {
        console.error('Failed to parse notification:', message.body, e);
      }
    });

    // Subscribe to visit updates
    this.client.subscribe(`/topic/visit-updates`, (message: IMessage) => {
      try {
        const payload = JSON.parse(message.body);
        this.visitUpdateSubject.next(payload);
      } catch (e) {
        console.error('Failed to parse visit update:', message.body, e);
      }
    });
  };

  this.client.onStompError = (frame) => {
    console.error('Broker error:', frame.headers['message']);
    console.error('Details:', frame.body);
  };

  this.client.activate();
}


  // connectWEB() {
  //   this.client.onConnect = () => {
  //     this.client.subscribe(`/topic/visit-updates`, (message: IMessage) => {
  //       try {
  //         const payload = JSON.parse(message.body);
  //         this.visitUpdateSubject.next(payload); // emit the visit update
  //       } catch (e) {
  //         console.error('Failed to parse notification:', message.body, e);
  //       }
  //     });
  //   };

  //   this.client.onStompError = (frame) => {
  //     console.error('Broker error:', frame.headers['message']);
  //     console.error('Details:', frame.body);
  //   };

  //   this.client.activate();
  // }

  getVisitUpdates(): Observable<any> {
    return this.visitUpdateSubject.asObservable();
  }

  disconnect() {
    if (this.client && this.client.active) {
      this.client.deactivate();
    }
  }

  getNotifications(): Observable<any> {
    return this.notificationSubject.asObservable();
  }
}
